import React, { memo } from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    height: 60,
    marginTop: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderTop: "1px solid #eef5fb",
    "@media print": {
      display: "none",
    },
  },
  progress: {
    color: theme.palette.secondary.main,
  },
}));

const copyright = `${new Date().getFullYear()} IPD Analytics, LLC`;

const FooterComponent: React.FC = memo(() => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <Typography variant="body2">
        &copy;
        {copyright}
      </Typography>
    </div>
  );
});

export default FooterComponent;
